export const mobileBreakpoint = 786;
export const newMobileViewBreakpoint = 600;
export const isMobileView = () => window.outerWidth <= mobileBreakpoint && !window.matchMedia('print').matches;
export const isNewMobileView = () => window.innerWidth <= newMobileViewBreakpoint &&
    !window.matchMedia('print').matches;
//# sourceMappingURL=isMobileView.js.map